module.exports = __webpack_public_path__ + "img/43.0473c023.png";